/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createDeliveredMessages = /* GraphQL */ `mutation CreateDeliveredMessages(
  $input: CreateDeliveredMessagesInput!
  $condition: ModelDeliveredMessagesConditionInput
) {
  createDeliveredMessages(input: $input, condition: $condition) {
    id
    recipientEmail
    recipientId
    recipientUserId
    deliveredAt
    deliveryType
    messageRead
    readReminderCount
    readReminderStatus
    status
    failureReason
    attemptCount
    lastAttemptAt
    statusUpdatedAt
    fromUserProfileId
    fromName
    fromEmail
    originalMessageId
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    hasAttachment
    attachmentCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDeliveredMessagesMutationVariables,
  APITypes.CreateDeliveredMessagesMutation
>;
export const updateDeliveredMessages = /* GraphQL */ `mutation UpdateDeliveredMessages(
  $input: UpdateDeliveredMessagesInput!
  $condition: ModelDeliveredMessagesConditionInput
) {
  updateDeliveredMessages(input: $input, condition: $condition) {
    id
    recipientEmail
    recipientId
    recipientUserId
    deliveredAt
    deliveryType
    messageRead
    readReminderCount
    readReminderStatus
    status
    failureReason
    attemptCount
    lastAttemptAt
    statusUpdatedAt
    fromUserProfileId
    fromName
    fromEmail
    originalMessageId
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    hasAttachment
    attachmentCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDeliveredMessagesMutationVariables,
  APITypes.UpdateDeliveredMessagesMutation
>;
export const deleteDeliveredMessages = /* GraphQL */ `mutation DeleteDeliveredMessages(
  $input: DeleteDeliveredMessagesInput!
  $condition: ModelDeliveredMessagesConditionInput
) {
  deleteDeliveredMessages(input: $input, condition: $condition) {
    id
    recipientEmail
    recipientId
    recipientUserId
    deliveredAt
    deliveryType
    messageRead
    readReminderCount
    readReminderStatus
    status
    failureReason
    attemptCount
    lastAttemptAt
    statusUpdatedAt
    fromUserProfileId
    fromName
    fromEmail
    originalMessageId
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    hasAttachment
    attachmentCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDeliveredMessagesMutationVariables,
  APITypes.DeleteDeliveredMessagesMutation
>;
export const createDeliveredMessagesAttachments = /* GraphQL */ `mutation CreateDeliveredMessagesAttachments(
  $input: CreateDeliveredMessagesAttachmentsInput!
  $condition: ModelDeliveredMessagesAttachmentsConditionInput
) {
  createDeliveredMessagesAttachments(input: $input, condition: $condition) {
    id
    deliveredMessageId
    recipientEmail
    fileName
    fileType
    fileSize
    s3Key
    uploadedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDeliveredMessagesAttachmentsMutationVariables,
  APITypes.CreateDeliveredMessagesAttachmentsMutation
>;
export const updateDeliveredMessagesAttachments = /* GraphQL */ `mutation UpdateDeliveredMessagesAttachments(
  $input: UpdateDeliveredMessagesAttachmentsInput!
  $condition: ModelDeliveredMessagesAttachmentsConditionInput
) {
  updateDeliveredMessagesAttachments(input: $input, condition: $condition) {
    id
    deliveredMessageId
    recipientEmail
    fileName
    fileType
    fileSize
    s3Key
    uploadedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDeliveredMessagesAttachmentsMutationVariables,
  APITypes.UpdateDeliveredMessagesAttachmentsMutation
>;
export const deleteDeliveredMessagesAttachments = /* GraphQL */ `mutation DeleteDeliveredMessagesAttachments(
  $input: DeleteDeliveredMessagesAttachmentsInput!
  $condition: ModelDeliveredMessagesAttachmentsConditionInput
) {
  deleteDeliveredMessagesAttachments(input: $input, condition: $condition) {
    id
    deliveredMessageId
    recipientEmail
    fileName
    fileType
    fileSize
    s3Key
    uploadedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDeliveredMessagesAttachmentsMutationVariables,
  APITypes.DeleteDeliveredMessagesAttachmentsMutation
>;
export const createMessageDeliveryLog = /* GraphQL */ `mutation CreateMessageDeliveryLog(
  $input: CreateMessageDeliveryLogInput!
  $condition: ModelMessageDeliveryLogConditionInput
) {
  createMessageDeliveryLog(input: $input, condition: $condition) {
    id
    executionId
    actionType
    entityType
    entityId
    originalMessageId
    deliveredMessageId
    recipientId
    previousStatus
    newStatus
    attemptNumber
    errorSummary
    changedFields
    timestamp
    functionName
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessageDeliveryLogMutationVariables,
  APITypes.CreateMessageDeliveryLogMutation
>;
export const updateMessageDeliveryLog = /* GraphQL */ `mutation UpdateMessageDeliveryLog(
  $input: UpdateMessageDeliveryLogInput!
  $condition: ModelMessageDeliveryLogConditionInput
) {
  updateMessageDeliveryLog(input: $input, condition: $condition) {
    id
    executionId
    actionType
    entityType
    entityId
    originalMessageId
    deliveredMessageId
    recipientId
    previousStatus
    newStatus
    attemptNumber
    errorSummary
    changedFields
    timestamp
    functionName
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageDeliveryLogMutationVariables,
  APITypes.UpdateMessageDeliveryLogMutation
>;
export const deleteMessageDeliveryLog = /* GraphQL */ `mutation DeleteMessageDeliveryLog(
  $input: DeleteMessageDeliveryLogInput!
  $condition: ModelMessageDeliveryLogConditionInput
) {
  deleteMessageDeliveryLog(input: $input, condition: $condition) {
    id
    executionId
    actionType
    entityType
    entityId
    originalMessageId
    deliveredMessageId
    recipientId
    previousStatus
    newStatus
    attemptNumber
    errorSummary
    changedFields
    timestamp
    functionName
    details
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessageDeliveryLogMutationVariables,
  APITypes.DeleteMessageDeliveryLogMutation
>;
export const createTestimonials = /* GraphQL */ `mutation CreateTestimonials(
  $input: CreateTestimonialsInput!
  $condition: ModelTestimonialsConditionInput
) {
  createTestimonials(input: $input, condition: $condition) {
    id
    Name
    Location
    Comment
    Active
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTestimonialsMutationVariables,
  APITypes.CreateTestimonialsMutation
>;
export const updateTestimonials = /* GraphQL */ `mutation UpdateTestimonials(
  $input: UpdateTestimonialsInput!
  $condition: ModelTestimonialsConditionInput
) {
  updateTestimonials(input: $input, condition: $condition) {
    id
    Name
    Location
    Comment
    Active
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTestimonialsMutationVariables,
  APITypes.UpdateTestimonialsMutation
>;
export const deleteTestimonials = /* GraphQL */ `mutation DeleteTestimonials(
  $input: DeleteTestimonialsInput!
  $condition: ModelTestimonialsConditionInput
) {
  deleteTestimonials(input: $input, condition: $condition) {
    id
    Name
    Location
    Comment
    Active
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTestimonialsMutationVariables,
  APITypes.DeleteTestimonialsMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    cognitoSub
    email
    status
    UserProfile {
      id
      firstName
      lastName
      preferredName
      dateOfBirth
      primaryPhone
      primaryPhoneType
      secondaryPhone
      secondaryPhoneType
      isActive
      isAlive
      eolVerificationCount
      lastEolVerificationResponseAt
      lastEolVerificationSentAt
      eolVerificationStatus
      currentEolVerificationCycleStartedAt
      lastEolVerificationMethod
      lastSuccessfulLoginAt
      Messages {
        nextToken
        __typename
      }
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    UserPreferences {
      id
      eolVerificationIntervalDays
      eolVerificationReminderCount
      eolVerificationReminderIntervalDays
      eolVerificationChannelEmailEnabled
      eolVerificationChannelSmsEnabled
      eolStopScheduledMessages
      minBodyWordCount
      eolAccountReaderRecipientId
      preferredLanguage
      createdAt
      updatedAt
      __typename
    }
    billingProviderId
    userPlanId
    pendingPlanId
    scheduledPlanId
    planStatus
    planSelectedAt
    planActivatedAt
    checkoutSessionRef
    checkoutMode
    pendingPaymentAmount
    pendingPaymentQuotedAt
    latestPaymentId
    currentPeriodEnd
    billingProvider
    billingCustomerRef
    subscriptionId
    ChangeLogs {
      items {
        id
        requestId
        changedById
        userId
        entityType
        entityId
        changeType
        fieldName
        oldValue
        newValue
        metadata
        dateTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    cognitoSub
    email
    status
    UserProfile {
      id
      firstName
      lastName
      preferredName
      dateOfBirth
      primaryPhone
      primaryPhoneType
      secondaryPhone
      secondaryPhoneType
      isActive
      isAlive
      eolVerificationCount
      lastEolVerificationResponseAt
      lastEolVerificationSentAt
      eolVerificationStatus
      currentEolVerificationCycleStartedAt
      lastEolVerificationMethod
      lastSuccessfulLoginAt
      Messages {
        nextToken
        __typename
      }
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    UserPreferences {
      id
      eolVerificationIntervalDays
      eolVerificationReminderCount
      eolVerificationReminderIntervalDays
      eolVerificationChannelEmailEnabled
      eolVerificationChannelSmsEnabled
      eolStopScheduledMessages
      minBodyWordCount
      eolAccountReaderRecipientId
      preferredLanguage
      createdAt
      updatedAt
      __typename
    }
    billingProviderId
    userPlanId
    pendingPlanId
    scheduledPlanId
    planStatus
    planSelectedAt
    planActivatedAt
    checkoutSessionRef
    checkoutMode
    pendingPaymentAmount
    pendingPaymentQuotedAt
    latestPaymentId
    currentPeriodEnd
    billingProvider
    billingCustomerRef
    subscriptionId
    ChangeLogs {
      items {
        id
        requestId
        changedById
        userId
        entityType
        entityId
        changeType
        fieldName
        oldValue
        newValue
        metadata
        dateTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    cognitoSub
    email
    status
    UserProfile {
      id
      firstName
      lastName
      preferredName
      dateOfBirth
      primaryPhone
      primaryPhoneType
      secondaryPhone
      secondaryPhoneType
      isActive
      isAlive
      eolVerificationCount
      lastEolVerificationResponseAt
      lastEolVerificationSentAt
      eolVerificationStatus
      currentEolVerificationCycleStartedAt
      lastEolVerificationMethod
      lastSuccessfulLoginAt
      Messages {
        nextToken
        __typename
      }
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    UserPreferences {
      id
      eolVerificationIntervalDays
      eolVerificationReminderCount
      eolVerificationReminderIntervalDays
      eolVerificationChannelEmailEnabled
      eolVerificationChannelSmsEnabled
      eolStopScheduledMessages
      minBodyWordCount
      eolAccountReaderRecipientId
      preferredLanguage
      createdAt
      updatedAt
      __typename
    }
    billingProviderId
    userPlanId
    pendingPlanId
    scheduledPlanId
    planStatus
    planSelectedAt
    planActivatedAt
    checkoutSessionRef
    checkoutMode
    pendingPaymentAmount
    pendingPaymentQuotedAt
    latestPaymentId
    currentPeriodEnd
    billingProvider
    billingCustomerRef
    subscriptionId
    ChangeLogs {
      items {
        id
        requestId
        changedById
        userId
        entityType
        entityId
        changeType
        fieldName
        oldValue
        newValue
        metadata
        dateTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createUserProfile = /* GraphQL */ `mutation CreateUserProfile(
  $input: CreateUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  createUserProfile(input: $input, condition: $condition) {
    id
    firstName
    lastName
    preferredName
    dateOfBirth
    primaryPhone
    primaryPhoneType
    secondaryPhone
    secondaryPhoneType
    isActive
    isAlive
    eolVerificationCount
    lastEolVerificationResponseAt
    lastEolVerificationSentAt
    eolVerificationStatus
    currentEolVerificationCycleStartedAt
    lastEolVerificationMethod
    lastSuccessfulLoginAt
    Messages {
      items {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Recipients {
      items {
        id
        firstName
        lastName
        email
        phone
        phoneType
        sendSMS
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        name
        description
        type
        status
        size
        s3Key
        uploadDate
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserProfileMutationVariables,
  APITypes.CreateUserProfileMutation
>;
export const updateUserProfile = /* GraphQL */ `mutation UpdateUserProfile(
  $input: UpdateUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  updateUserProfile(input: $input, condition: $condition) {
    id
    firstName
    lastName
    preferredName
    dateOfBirth
    primaryPhone
    primaryPhoneType
    secondaryPhone
    secondaryPhoneType
    isActive
    isAlive
    eolVerificationCount
    lastEolVerificationResponseAt
    lastEolVerificationSentAt
    eolVerificationStatus
    currentEolVerificationCycleStartedAt
    lastEolVerificationMethod
    lastSuccessfulLoginAt
    Messages {
      items {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Recipients {
      items {
        id
        firstName
        lastName
        email
        phone
        phoneType
        sendSMS
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        name
        description
        type
        status
        size
        s3Key
        uploadDate
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserProfileMutationVariables,
  APITypes.UpdateUserProfileMutation
>;
export const deleteUserProfile = /* GraphQL */ `mutation DeleteUserProfile(
  $input: DeleteUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  deleteUserProfile(input: $input, condition: $condition) {
    id
    firstName
    lastName
    preferredName
    dateOfBirth
    primaryPhone
    primaryPhoneType
    secondaryPhone
    secondaryPhoneType
    isActive
    isAlive
    eolVerificationCount
    lastEolVerificationResponseAt
    lastEolVerificationSentAt
    eolVerificationStatus
    currentEolVerificationCycleStartedAt
    lastEolVerificationMethod
    lastSuccessfulLoginAt
    Messages {
      items {
        id
        title
        body
        bodyIv
        bodyAuthTag
        bodyEncryptedDataKey
        bodySnippet
        status
        scheduledDate
        endOfLifeTrigger
        size
        userprofileID
        sentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Recipients {
      items {
        id
        firstName
        lastName
        email
        phone
        phoneType
        sendSMS
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        name
        description
        type
        status
        size
        s3Key
        uploadDate
        userprofileID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserProfileMutationVariables,
  APITypes.DeleteUserProfileMutation
>;
export const createUserPreferences = /* GraphQL */ `mutation CreateUserPreferences(
  $input: CreateUserPreferencesInput!
  $condition: ModelUserPreferencesConditionInput
) {
  createUserPreferences(input: $input, condition: $condition) {
    id
    eolVerificationIntervalDays
    eolVerificationReminderCount
    eolVerificationReminderIntervalDays
    eolVerificationChannelEmailEnabled
    eolVerificationChannelSmsEnabled
    eolStopScheduledMessages
    minBodyWordCount
    eolAccountReaderRecipientId
    preferredLanguage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserPreferencesMutationVariables,
  APITypes.CreateUserPreferencesMutation
>;
export const updateUserPreferences = /* GraphQL */ `mutation UpdateUserPreferences(
  $input: UpdateUserPreferencesInput!
  $condition: ModelUserPreferencesConditionInput
) {
  updateUserPreferences(input: $input, condition: $condition) {
    id
    eolVerificationIntervalDays
    eolVerificationReminderCount
    eolVerificationReminderIntervalDays
    eolVerificationChannelEmailEnabled
    eolVerificationChannelSmsEnabled
    eolStopScheduledMessages
    minBodyWordCount
    eolAccountReaderRecipientId
    preferredLanguage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserPreferencesMutationVariables,
  APITypes.UpdateUserPreferencesMutation
>;
export const deleteUserPreferences = /* GraphQL */ `mutation DeleteUserPreferences(
  $input: DeleteUserPreferencesInput!
  $condition: ModelUserPreferencesConditionInput
) {
  deleteUserPreferences(input: $input, condition: $condition) {
    id
    eolVerificationIntervalDays
    eolVerificationReminderCount
    eolVerificationReminderIntervalDays
    eolVerificationChannelEmailEnabled
    eolVerificationChannelSmsEnabled
    eolStopScheduledMessages
    minBodyWordCount
    eolAccountReaderRecipientId
    preferredLanguage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserPreferencesMutationVariables,
  APITypes.DeleteUserPreferencesMutation
>;
export const createEolVerificationToken = /* GraphQL */ `mutation CreateEolVerificationToken(
  $input: CreateEolVerificationTokenInput!
  $condition: ModelEolVerificationTokenConditionInput
) {
  createEolVerificationToken(input: $input, condition: $condition) {
    id
    userId
    cycleId
    tokenHash
    status
    issuedAt
    expiresAt
    usedAt
    channel
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEolVerificationTokenMutationVariables,
  APITypes.CreateEolVerificationTokenMutation
>;
export const updateEolVerificationToken = /* GraphQL */ `mutation UpdateEolVerificationToken(
  $input: UpdateEolVerificationTokenInput!
  $condition: ModelEolVerificationTokenConditionInput
) {
  updateEolVerificationToken(input: $input, condition: $condition) {
    id
    userId
    cycleId
    tokenHash
    status
    issuedAt
    expiresAt
    usedAt
    channel
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEolVerificationTokenMutationVariables,
  APITypes.UpdateEolVerificationTokenMutation
>;
export const deleteEolVerificationToken = /* GraphQL */ `mutation DeleteEolVerificationToken(
  $input: DeleteEolVerificationTokenInput!
  $condition: ModelEolVerificationTokenConditionInput
) {
  deleteEolVerificationToken(input: $input, condition: $condition) {
    id
    userId
    cycleId
    tokenHash
    status
    issuedAt
    expiresAt
    usedAt
    channel
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEolVerificationTokenMutationVariables,
  APITypes.DeleteEolVerificationTokenMutation
>;
export const createRecipient = /* GraphQL */ `mutation CreateRecipient(
  $input: CreateRecipientInput!
  $condition: ModelRecipientConditionInput
) {
  createRecipient(input: $input, condition: $condition) {
    id
    firstName
    lastName
    email
    phone
    phoneType
    sendSMS
    userprofileID
    messages {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecipientMutationVariables,
  APITypes.CreateRecipientMutation
>;
export const updateRecipient = /* GraphQL */ `mutation UpdateRecipient(
  $input: UpdateRecipientInput!
  $condition: ModelRecipientConditionInput
) {
  updateRecipient(input: $input, condition: $condition) {
    id
    firstName
    lastName
    email
    phone
    phoneType
    sendSMS
    userprofileID
    messages {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecipientMutationVariables,
  APITypes.UpdateRecipientMutation
>;
export const deleteRecipient = /* GraphQL */ `mutation DeleteRecipient(
  $input: DeleteRecipientInput!
  $condition: ModelRecipientConditionInput
) {
  deleteRecipient(input: $input, condition: $condition) {
    id
    firstName
    lastName
    email
    phone
    phoneType
    sendSMS
    userprofileID
    messages {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecipientMutationVariables,
  APITypes.DeleteRecipientMutation
>;
export const createMessage = /* GraphQL */ `mutation CreateMessage(
  $input: CreateMessageInput!
  $condition: ModelMessageConditionInput
) {
  createMessage(input: $input, condition: $condition) {
    id
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    status
    scheduledDate
    endOfLifeTrigger
    size
    userprofileID
    Recipients {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sentDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessageMutationVariables,
  APITypes.CreateMessageMutation
>;
export const updateMessage = /* GraphQL */ `mutation UpdateMessage(
  $input: UpdateMessageInput!
  $condition: ModelMessageConditionInput
) {
  updateMessage(input: $input, condition: $condition) {
    id
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    status
    scheduledDate
    endOfLifeTrigger
    size
    userprofileID
    Recipients {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sentDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageMutationVariables,
  APITypes.UpdateMessageMutation
>;
export const deleteMessage = /* GraphQL */ `mutation DeleteMessage(
  $input: DeleteMessageInput!
  $condition: ModelMessageConditionInput
) {
  deleteMessage(input: $input, condition: $condition) {
    id
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    status
    scheduledDate
    endOfLifeTrigger
    size
    userprofileID
    Recipients {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sentDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessageMutationVariables,
  APITypes.DeleteMessageMutation
>;
export const createPlan = /* GraphQL */ `mutation CreatePlan(
  $input: CreatePlanInput!
  $condition: ModelPlanConditionInput
) {
  createPlan(input: $input, condition: $condition) {
    id
    name
    description
    type
    price
    billingCycle
    status
    messagesAllowed
    attachmentsAllowed
    recipientsAllowed
    billingProviderId
    checkoutMode
    priceId
    billingConfig
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePlanMutationVariables,
  APITypes.CreatePlanMutation
>;
export const updatePlan = /* GraphQL */ `mutation UpdatePlan(
  $input: UpdatePlanInput!
  $condition: ModelPlanConditionInput
) {
  updatePlan(input: $input, condition: $condition) {
    id
    name
    description
    type
    price
    billingCycle
    status
    messagesAllowed
    attachmentsAllowed
    recipientsAllowed
    billingProviderId
    checkoutMode
    priceId
    billingConfig
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlanMutationVariables,
  APITypes.UpdatePlanMutation
>;
export const deletePlan = /* GraphQL */ `mutation DeletePlan(
  $input: DeletePlanInput!
  $condition: ModelPlanConditionInput
) {
  deletePlan(input: $input, condition: $condition) {
    id
    name
    description
    type
    price
    billingCycle
    status
    messagesAllowed
    attachmentsAllowed
    recipientsAllowed
    billingProviderId
    checkoutMode
    priceId
    billingConfig
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePlanMutationVariables,
  APITypes.DeletePlanMutation
>;
export const createBillingProvider = /* GraphQL */ `mutation CreateBillingProvider(
  $input: CreateBillingProviderInput!
  $condition: ModelBillingProviderConditionInput
) {
  createBillingProvider(input: $input, condition: $condition) {
    id
    billingProviderId
    billingProviderName
    providerCode
    isActive
    checkoutMode
    webhookEnabled
    apiBaseUrl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBillingProviderMutationVariables,
  APITypes.CreateBillingProviderMutation
>;
export const updateBillingProvider = /* GraphQL */ `mutation UpdateBillingProvider(
  $input: UpdateBillingProviderInput!
  $condition: ModelBillingProviderConditionInput
) {
  updateBillingProvider(input: $input, condition: $condition) {
    id
    billingProviderId
    billingProviderName
    providerCode
    isActive
    checkoutMode
    webhookEnabled
    apiBaseUrl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBillingProviderMutationVariables,
  APITypes.UpdateBillingProviderMutation
>;
export const deleteBillingProvider = /* GraphQL */ `mutation DeleteBillingProvider(
  $input: DeleteBillingProviderInput!
  $condition: ModelBillingProviderConditionInput
) {
  deleteBillingProvider(input: $input, condition: $condition) {
    id
    billingProviderId
    billingProviderName
    providerCode
    isActive
    checkoutMode
    webhookEnabled
    apiBaseUrl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBillingProviderMutationVariables,
  APITypes.DeleteBillingProviderMutation
>;
export const createAttachment = /* GraphQL */ `mutation CreateAttachment(
  $input: CreateAttachmentInput!
  $condition: ModelAttachmentConditionInput
) {
  createAttachment(input: $input, condition: $condition) {
    id
    name
    description
    type
    status
    size
    s3Key
    uploadDate
    userprofileID
    messages {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttachmentMutationVariables,
  APITypes.CreateAttachmentMutation
>;
export const updateAttachment = /* GraphQL */ `mutation UpdateAttachment(
  $input: UpdateAttachmentInput!
  $condition: ModelAttachmentConditionInput
) {
  updateAttachment(input: $input, condition: $condition) {
    id
    name
    description
    type
    status
    size
    s3Key
    uploadDate
    userprofileID
    messages {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAttachmentMutationVariables,
  APITypes.UpdateAttachmentMutation
>;
export const deleteAttachment = /* GraphQL */ `mutation DeleteAttachment(
  $input: DeleteAttachmentInput!
  $condition: ModelAttachmentConditionInput
) {
  deleteAttachment(input: $input, condition: $condition) {
    id
    name
    description
    type
    status
    size
    s3Key
    uploadDate
    userprofileID
    messages {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttachmentMutationVariables,
  APITypes.DeleteAttachmentMutation
>;
export const createChangeLog = /* GraphQL */ `mutation CreateChangeLog(
  $input: CreateChangeLogInput!
  $condition: ModelChangeLogConditionInput
) {
  createChangeLog(input: $input, condition: $condition) {
    id
    requestId
    changedById
    userId
    entityType
    entityId
    changeType
    fieldName
    oldValue
    newValue
    metadata
    dateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChangeLogMutationVariables,
  APITypes.CreateChangeLogMutation
>;
export const updateChangeLog = /* GraphQL */ `mutation UpdateChangeLog(
  $input: UpdateChangeLogInput!
  $condition: ModelChangeLogConditionInput
) {
  updateChangeLog(input: $input, condition: $condition) {
    id
    requestId
    changedById
    userId
    entityType
    entityId
    changeType
    fieldName
    oldValue
    newValue
    metadata
    dateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateChangeLogMutationVariables,
  APITypes.UpdateChangeLogMutation
>;
export const deleteChangeLog = /* GraphQL */ `mutation DeleteChangeLog(
  $input: DeleteChangeLogInput!
  $condition: ModelChangeLogConditionInput
) {
  deleteChangeLog(input: $input, condition: $condition) {
    id
    requestId
    changedById
    userId
    entityType
    entityId
    changeType
    fieldName
    oldValue
    newValue
    metadata
    dateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChangeLogMutationVariables,
  APITypes.DeleteChangeLogMutation
>;
export const createLegalAcceptance = /* GraphQL */ `mutation CreateLegalAcceptance(
  $input: CreateLegalAcceptanceInput!
  $condition: ModelLegalAcceptanceConditionInput
) {
  createLegalAcceptance(input: $input, condition: $condition) {
    id
    userId
    version
    acceptedAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLegalAcceptanceMutationVariables,
  APITypes.CreateLegalAcceptanceMutation
>;
export const updateLegalAcceptance = /* GraphQL */ `mutation UpdateLegalAcceptance(
  $input: UpdateLegalAcceptanceInput!
  $condition: ModelLegalAcceptanceConditionInput
) {
  updateLegalAcceptance(input: $input, condition: $condition) {
    id
    userId
    version
    acceptedAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLegalAcceptanceMutationVariables,
  APITypes.UpdateLegalAcceptanceMutation
>;
export const deleteLegalAcceptance = /* GraphQL */ `mutation DeleteLegalAcceptance(
  $input: DeleteLegalAcceptanceInput!
  $condition: ModelLegalAcceptanceConditionInput
) {
  deleteLegalAcceptance(input: $input, condition: $condition) {
    id
    userId
    version
    acceptedAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLegalAcceptanceMutationVariables,
  APITypes.DeleteLegalAcceptanceMutation
>;
export const createLoginEvent = /* GraphQL */ `mutation CreateLoginEvent(
  $input: CreateLoginEventInput!
  $condition: ModelLoginEventConditionInput
) {
  createLoginEvent(input: $input, condition: $condition) {
    id
    userId
    eventType
    occurredAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    authMethod
    mfaUsed
    ipHash
    country
    region
    city
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLoginEventMutationVariables,
  APITypes.CreateLoginEventMutation
>;
export const updateLoginEvent = /* GraphQL */ `mutation UpdateLoginEvent(
  $input: UpdateLoginEventInput!
  $condition: ModelLoginEventConditionInput
) {
  updateLoginEvent(input: $input, condition: $condition) {
    id
    userId
    eventType
    occurredAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    authMethod
    mfaUsed
    ipHash
    country
    region
    city
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLoginEventMutationVariables,
  APITypes.UpdateLoginEventMutation
>;
export const deleteLoginEvent = /* GraphQL */ `mutation DeleteLoginEvent(
  $input: DeleteLoginEventInput!
  $condition: ModelLoginEventConditionInput
) {
  deleteLoginEvent(input: $input, condition: $condition) {
    id
    userId
    eventType
    occurredAt
    sessionId
    sourceApp
    clientType
    browser
    os
    userAgent
    authMethod
    mfaUsed
    ipHash
    country
    region
    city
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLoginEventMutationVariables,
  APITypes.DeleteLoginEventMutation
>;
export const createBillingEventLog = /* GraphQL */ `mutation CreateBillingEventLog(
  $input: CreateBillingEventLogInput!
  $condition: ModelBillingEventLogConditionInput
) {
  createBillingEventLog(input: $input, condition: $condition) {
    id
    userId
    provider
    providerEventId
    providerCustomerRef
    providerResourceRef
    eventType
    status
    planId
    amount
    currency
    occurredAt
    receivedAt
    processedAt
    message
    rawPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBillingEventLogMutationVariables,
  APITypes.CreateBillingEventLogMutation
>;
export const updateBillingEventLog = /* GraphQL */ `mutation UpdateBillingEventLog(
  $input: UpdateBillingEventLogInput!
  $condition: ModelBillingEventLogConditionInput
) {
  updateBillingEventLog(input: $input, condition: $condition) {
    id
    userId
    provider
    providerEventId
    providerCustomerRef
    providerResourceRef
    eventType
    status
    planId
    amount
    currency
    occurredAt
    receivedAt
    processedAt
    message
    rawPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBillingEventLogMutationVariables,
  APITypes.UpdateBillingEventLogMutation
>;
export const deleteBillingEventLog = /* GraphQL */ `mutation DeleteBillingEventLog(
  $input: DeleteBillingEventLogInput!
  $condition: ModelBillingEventLogConditionInput
) {
  deleteBillingEventLog(input: $input, condition: $condition) {
    id
    userId
    provider
    providerEventId
    providerCustomerRef
    providerResourceRef
    eventType
    status
    planId
    amount
    currency
    occurredAt
    receivedAt
    processedAt
    message
    rawPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBillingEventLogMutationVariables,
  APITypes.DeleteBillingEventLogMutation
>;
export const createMessageRecipient = /* GraphQL */ `mutation CreateMessageRecipient(
  $input: CreateMessageRecipientInput!
  $condition: ModelMessageRecipientConditionInput
) {
  createMessageRecipient(input: $input, condition: $condition) {
    id
    recipientId
    messageId
    recipient {
      id
      firstName
      lastName
      email
      phone
      phoneType
      sendSMS
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessageRecipientMutationVariables,
  APITypes.CreateMessageRecipientMutation
>;
export const updateMessageRecipient = /* GraphQL */ `mutation UpdateMessageRecipient(
  $input: UpdateMessageRecipientInput!
  $condition: ModelMessageRecipientConditionInput
) {
  updateMessageRecipient(input: $input, condition: $condition) {
    id
    recipientId
    messageId
    recipient {
      id
      firstName
      lastName
      email
      phone
      phoneType
      sendSMS
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageRecipientMutationVariables,
  APITypes.UpdateMessageRecipientMutation
>;
export const deleteMessageRecipient = /* GraphQL */ `mutation DeleteMessageRecipient(
  $input: DeleteMessageRecipientInput!
  $condition: ModelMessageRecipientConditionInput
) {
  deleteMessageRecipient(input: $input, condition: $condition) {
    id
    recipientId
    messageId
    recipient {
      id
      firstName
      lastName
      email
      phone
      phoneType
      sendSMS
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessageRecipientMutationVariables,
  APITypes.DeleteMessageRecipientMutation
>;
export const createMessageAttachment = /* GraphQL */ `mutation CreateMessageAttachment(
  $input: CreateMessageAttachmentInput!
  $condition: ModelMessageAttachmentConditionInput
) {
  createMessageAttachment(input: $input, condition: $condition) {
    id
    messageId
    attachmentId
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    attachment {
      id
      name
      description
      type
      status
      size
      s3Key
      uploadDate
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessageAttachmentMutationVariables,
  APITypes.CreateMessageAttachmentMutation
>;
export const updateMessageAttachment = /* GraphQL */ `mutation UpdateMessageAttachment(
  $input: UpdateMessageAttachmentInput!
  $condition: ModelMessageAttachmentConditionInput
) {
  updateMessageAttachment(input: $input, condition: $condition) {
    id
    messageId
    attachmentId
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    attachment {
      id
      name
      description
      type
      status
      size
      s3Key
      uploadDate
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageAttachmentMutationVariables,
  APITypes.UpdateMessageAttachmentMutation
>;
export const deleteMessageAttachment = /* GraphQL */ `mutation DeleteMessageAttachment(
  $input: DeleteMessageAttachmentInput!
  $condition: ModelMessageAttachmentConditionInput
) {
  deleteMessageAttachment(input: $input, condition: $condition) {
    id
    messageId
    attachmentId
    message {
      id
      title
      body
      bodyIv
      bodyAuthTag
      bodyEncryptedDataKey
      bodySnippet
      status
      scheduledDate
      endOfLifeTrigger
      size
      userprofileID
      Recipients {
        nextToken
        __typename
      }
      Attachments {
        nextToken
        __typename
      }
      sentDate
      createdAt
      updatedAt
      __typename
    }
    attachment {
      id
      name
      description
      type
      status
      size
      s3Key
      uploadDate
      userprofileID
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMessageAttachmentMutationVariables,
  APITypes.DeleteMessageAttachmentMutation
>;
export const createMessageWithBody = /* GraphQL */ `mutation CreateMessageWithBody($input: CreateMessageWithBodyInput!) {
  createMessageWithBody(input: $input) {
    id
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    status
    scheduledDate
    endOfLifeTrigger
    size
    userprofileID
    Recipients {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sentDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMessageWithBodyMutationVariables,
  APITypes.CreateMessageWithBodyMutation
>;
export const updateMessageWithBody = /* GraphQL */ `mutation UpdateMessageWithBody($input: UpdateMessageWithBodyInput!) {
  updateMessageWithBody(input: $input) {
    id
    title
    body
    bodyIv
    bodyAuthTag
    bodyEncryptedDataKey
    bodySnippet
    status
    scheduledDate
    endOfLifeTrigger
    size
    userprofileID
    Recipients {
      items {
        id
        recipientId
        messageId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    Attachments {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    sentDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMessageWithBodyMutationVariables,
  APITypes.UpdateMessageWithBodyMutation
>;
export const createAttachmentWithPlatformGuards = /* GraphQL */ `mutation CreateAttachmentWithPlatformGuards(
  $input: CreateAttachmentWithPlatformGuardsInput!
) {
  createAttachmentWithPlatformGuards(input: $input) {
    id
    name
    description
    type
    status
    size
    s3Key
    uploadDate
    userprofileID
    messages {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttachmentWithPlatformGuardsMutationVariables,
  APITypes.CreateAttachmentWithPlatformGuardsMutation
>;
export const updateAttachmentWithPlatformGuards = /* GraphQL */ `mutation UpdateAttachmentWithPlatformGuards(
  $input: UpdateAttachmentWithPlatformGuardsInput!
) {
  updateAttachmentWithPlatformGuards(input: $input) {
    id
    name
    description
    type
    status
    size
    s3Key
    uploadDate
    userprofileID
    messages {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAttachmentWithPlatformGuardsMutationVariables,
  APITypes.UpdateAttachmentWithPlatformGuardsMutation
>;
export const deleteAttachmentWithPlatformGuards = /* GraphQL */ `mutation DeleteAttachmentWithPlatformGuards($id: ID!) {
  deleteAttachmentWithPlatformGuards(id: $id) {
    id
    name
    description
    type
    status
    size
    s3Key
    uploadDate
    userprofileID
    messages {
      items {
        id
        messageId
        attachmentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttachmentWithPlatformGuardsMutationVariables,
  APITypes.DeleteAttachmentWithPlatformGuardsMutation
>;
export const downloadDeliveredMessageAttachments = /* GraphQL */ `mutation DownloadDeliveredMessageAttachments(
  $deliveredMessageId: ID!
  $attachmentIds: [ID!]
) {
  downloadDeliveredMessageAttachments(
    deliveredMessageId: $deliveredMessageId
    attachmentIds: $attachmentIds
  ) {
    items {
      id
      fileName
      fileType
      downloadUrl
      __typename
    }
    failures {
      id
      fileName
      reasonCode
      reasonMessage
      __typename
    }
    hasPartialFailure
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DownloadDeliveredMessageAttachmentsMutationVariables,
  APITypes.DownloadDeliveredMessageAttachmentsMutation
>;
export const confirmEolVerification = /* GraphQL */ `mutation ConfirmEolVerification($token: String!) {
  confirmEolVerification(token: $token) {
    outcome
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ConfirmEolVerificationMutationVariables,
  APITypes.ConfirmEolVerificationMutation
>;
